import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import type {
  MarkAsReadNotificationRequestBodyDto,
  MarkAsReadNotificationResponse,
} from 'viewup-api/v2';

export const markAsReadNotification = async (
  req: MarkAsReadNotificationRequestBodyDto,
): Promise<MarkAsReadNotificationResponse> => {
  const response = await serviceApi.notification.markAsReadNotification(
    withServiceRequestDefaults({ markAsReadNotificationRequestBodyDto: req }),
  );

  return response.data;
};
